// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExecutionRequest
 */
export interface ExecutionRequest {
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  inputs: { [key: string]: any };
  /**
   *
   */
  outputs?: { [key: string]: any };
  /**
   *
   */
  name?: string;
  /**
   * Workflow ID
   */
  workflowId?: string | null;
}

/**
 * Check if a given object implements the ExecutionRequest interface.
 */
export function instanceOfExecutionRequest(value: object): value is ExecutionRequest {
  if (
    (!("projectId" in (value as Record<string, any>)) &&
      !("project_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectId"] === undefined &&
      (value as Record<string, any>)["project_id"] === undefined)
  )
    return false;
  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  return true;
}

export function ExecutionRequestFromJSON(json: any): ExecutionRequest {
  return ExecutionRequestFromJSONTyped(json, false);
}

export function ExecutionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExecutionRequest {
  if (json == null) {
    return json;
  }
  return {
    projectId: json["project_id"],
    inputs: json["inputs"],
    outputs: json["outputs"] == null ? undefined : json["outputs"],
    name: json["name"] == null ? undefined : json["name"],
    workflowId:
      json["workflow_id"] === undefined
        ? undefined
        : json["workflow_id"] === null
        ? null
        : json["workflow_id"],
  };
}

export function ExecutionRequestToJSON(json: any): ExecutionRequest {
  return ExecutionRequestToJSONTyped(json, false);
}

export function ExecutionRequestToJSONTyped(
  value?: ExecutionRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    project_id: value["projectId"],
    inputs: value["inputs"],
    outputs: value["outputs"],
    name: value["name"],
    workflow_id: value["workflowId"],
  };
}
